import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownload2Line = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20 15C20.5523 15 21 15.4477 21 16V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V16C3 15.4477 3.44772 15 4 15C4.55228 15 5 15.4477 5 16V20H19V16C19 15.4477 19.4477 15 20 15ZM12 2C12.5523 2 13 2.44772 13 3V13.2426L15.5355 10.7071C15.9261 10.3165 16.5592 10.3165 16.9497 10.7071C17.3403 11.0976 17.3403 11.7308 16.9497 12.1213L12.8839 16.1871C12.3957 16.6753 11.6043 16.6753 11.1161 16.1871L7.05025 12.1213C6.65973 11.7308 6.65973 11.0976 7.05025 10.7071C7.44078 10.3165 8.07394 10.3165 8.46447 10.7071L11 13.2426V3C11 2.44772 11.4477 2 12 2Z" })
});
export default SvgDownload2Line;
